module.exports = __webpack_public_path__ + "img/event-bg-0.bcb18873.jpg";